import { mutationProcedure } from '../trpc/common.js';
import { z } from 'zod/v4-mini';
import { join } from 'path';
import { spawnSync } from 'child_process';
import type { ApiParams } from '../types/ApiParams.js';
import { environmentInfo } from '@ms-cloudpack/environment';
import { matchingZodObject } from '../utilities/matchingZodObject.js';

export interface OpenFilePathInput {
  /** Root folder path */
  rootPath: string;
  /** File/folder path relative to `rootPath`. If not provided, opens `rootPath`. */
  relativePath?: string;
}

const ZodOpenFilePathInput = matchingZodObject<OpenFilePathInput>({
  rootPath: z.string(),
  relativePath: z.optional(z.string()),
});

/**
 * Open a file or folder using the OS default application.
 */
export function openFilePath(params: ApiParams<OpenFilePathInput, 'session', 'config'>): void {
  const {
    input: { rootPath, relativePath },
    ctx: { session },
  } = params;
  const fullPath = join(rootPath, relativePath || '');

  console.log(`Opening path: ${fullPath}`);

  spawnSync(environmentInfo.isWindows ? 'start' : 'open', [fullPath], {
    cwd: session.config.appPath,
    shell: environmentInfo.isWindows ? 'powershell.exe' : false,
    stdio: 'inherit',
  });
}

// Attach a trpc procedure to the function.
openFilePath.procedure = mutationProcedure<OpenFilePathInput, void>(openFilePath, ZodOpenFilePathInput, z.void());
